import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=89c6d302&scoped=true&"
import script from "./ChangeHistory.vue?vue&type=script&lang=ts&"
export * from "./ChangeHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=89c6d302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c6d302",
  null
  
)

export default component.exports